import { jsx as i } from "react/jsx-runtime";
import { forwardRef as a } from "react";
import h from "./index.es2433.js";
import { useScreenZoomSize as S } from "./index.es589.js";
import { PrimitiveTooltip as g } from "./index.es2429.js";
const u = "simple-tooltip", w = a(
  ({
    title: o,
    maxWidth: s,
    testId: e = u,
    children: m,
    isActive: p = !0,
    ...c
  }, d) => {
    var r, n;
    const t = typeof o == "string" && o !== void 0, f = S() === "max", T = p && !!o && (t ? (o == null ? void 0 : o.length) > 0 : (n = (r = o == null ? void 0 : o.props) == null ? void 0 : r.children) == null ? void 0 : n.length);
    return /* @__PURE__ */ i(
      g,
      {
        testId: e,
        tooltipTrigger: m,
        isActive: T,
        ref: d,
        ...c,
        children: /* @__PURE__ */ i(
          "div",
          {
            className: h.truncate,
            style: { width: f ? 300 : "unset", maxWidth: s, whiteSpace: "normal" },
            children: o
          }
        )
      }
    );
  }
);
export {
  u as SIMPLE_TOOL_TIP_DEFAULT_TESTID,
  w as SimpleTooltip
};
//# sourceMappingURL=index.es127.js.map
